const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrubank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#614ad9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.23c-.13-.19-.2-.41-.2-.64,0-.31.12-.6.34-.82.22-.22.51-.34.82-.34.23,0,.45.07.65.19.19.13.34.31.43.52.09.21.11.44.07.67-.04.22-.16.43-.32.59-.16.16-.37.27-.59.32-.23.04-.46.02-.67-.07-.21-.09-.39-.24-.52-.43ZM5.26,4.67c-.16.16-.25.37-.25.59v4.38c0,2.17,1.79,3.93,4,3.93s4-1.76,4-3.93-1.79-3.9-4-3.9c-.11,0-.22.02-.32.06-.1.04-.19.1-.27.18s-.14.17-.18.27-.06.21-.06.32.02.22.06.32.1.19.18.27.17.14.27.18c.1.04.21.06.32.06,1.29,0,2.32.98,2.32,2.22s-1.03,2.26-2.32,2.26-2.32-1.01-2.32-2.26v-4.38c0-.22-.09-.43-.25-.59s-.37-.25-.59-.25-.44.09-.59.25Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrubank);
export default __webpack_public_path__ + "static/media/brubank.4638fc0a58558fffff4a7b35f8c9080c.svg";
export { ForwardRef as ReactComponent };